<div class="container-fluid spacer-top-navigation">
  <div class="container kryptoonboarding">
    <div class="tile row--primary">
      <h2>Adresse bestätigen</h2>
      @if (cryptoOnboardingFacade.customerAddress$ | async; as customerAddress) {
        <div class="row mt-4">
          <div class="col">
            <p>
              Um den Handel mit Kryptowährungen für Dich freischalten zu können, benötigen wir aktuelle Daten von Dir. Bitte überprüfe, ob
              sich an den bei uns vorliegenden Daten etwas geändert hat.
            </p>
          </div>
        </div>
        <div class="row mt-5">
          <div class="col-12 col-sm-6 mb-4">
            <div class="input-group-material">
              <input id="vorname" type="text" [value]="customerAddress?.firstName" disabled />
              <label for="vorname">Vorname</label>
            </div>
          </div>
          <div class="col-12 col-sm-6 mb-4">
            <div class="input-group-material">
              <input id="nachname" type="text" [value]="customerAddress?.lastName" disabled />
              <label for="nachname">Nachname</label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 mb-4">
            <div class="input-group-material">
              <input id="strasse" type="text" [value]="customerAddress?.street + ' ' + customerAddress?.streetNr" disabled />
              <label for="strasse">Straße und Hausnummer</label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 mb-4">
            <div class="input-group-material">
              <input id="addresszusatz" type="text" [value]="customerAddress?.additionalAddress || '-'" disabled />
              <label for="addresszusatz">Adresszusatz</label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-sm-6 mb-4">
            <div class="input-group-material">
              <input id="plz" type="text" [value]="customerAddress?.postalCode" disabled />
              <label for="plz">PLZ</label>
            </div>
          </div>
          <div class="col-12 col-sm-6 mb-4">
            <div class="input-group-material">
              <input id="ort" type="text" [value]="customerAddress?.city" disabled />
              <label for="ort">Ort</label>
            </div>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col">
            <h3>Adresse nicht mehr aktuell?</h3>
            <p class="mt-3">
              Bitte aktualisere Deine Adressdaten unter
              <a [routerLink]="commonRoutes.postlogin.verwaltung" class="link-secondary text-default">Verwaltung</a> und setze die Eröffnung
              Deiner Wallet fort.
            </p>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-12 col-sm-6 d-flex justify-content-center order-1 order-sm-0 mt-2 mt-sm-0 align-items-center">
            <a [routerLink]="commonRoutes.postlogin.kryptoOnboarding" class="link-secondary text-default">zurück</a>
          </div>
          <div class="col-12 col-sm-6 d-flex justify-content-center align-items-center">
            <web-design-system-button size="large" (click)="cryptoOnboardingFacade.confirmAddress()">
              Bestätigen und weiter
            </web-design-system-button>
          </div>
        </div>
      }
    </div>
  </div>
</div>
